module.exports = __webpack_public_path__ + "img/heart-white.36705555.svg";